<template>
  <header class="header-container">
    <div class="header-container__hero">
      <div class="header-container__overlay"></div>
      <div class="header-container__hero-content">
        <h1>Zadbaj o zdrowie swojego pupila bez wychodzenia z domu</h1>
        <p>Konsultacje weterynaryjne, porady behawioralne i usługi dla zwierząt.</p>
        <router-link to="/spec-browser" class="find-specialist-btn">
          Znajdź specjalistę
        </router-link>
      </div>
    </div>

    <div class="header-container__hsearch-bar-wrap">
      <HintComponent page-key="home_page" :absolute="true" />
      <h2>Wyszukaj usługę</h2>
      <div class="header-container__hsearch-bar">
        <DropdownVue
            :items="states"
            placeholder="województwo"
            id="stateDropdown"
            v-model="state"
            @setChecked="(e) => state = e"
        />
        <InputVue
            type="text"
            placeholder="Jakiej usługi szukasz?"
            id="searchBarInput"
            v-model="name"
        />
        <SearchFormButton @click="() => {
          if(`${state}${currentCategory}${name}` === 'placeholder' || state === 'placeholder'){
            appStore.setIsAlert('Prosimy uzupełnić województwo i wpisać nazwę usługi')
          }else{
            if(name.length > 2 || name.length === 0){
              setSearchParams()
            }else{
              appStore.setIsAlert('Wpisz minimum 3 litery')
            }
          }
        }">
          Wyszukaj
        </SearchFormButton>
      </div>

      <div class="header-container__hservices-list">
        <button
            class="header-container__hservices-list__srv-btn"
            type="button"
            v-for="category in categories"
            :key="category.id"
            :class="{ active: currentCategory === category.id }"
            @click="() => currentCategory = category.id"
        >
          <span class="header-container__hservices-list__srv-label">{{ category.name }}</span>
        </button>
      </div>
    </div>
  </header>
</template>

<script>
import axios from 'axios';
import DropdownVue from '@/components/Dropdown.vue';
import InputVue from '@/components/Input.vue';
import SearchFormButton from '@/components/HomeComponents/home/SearchFormButton.vue';
import { useAppStore } from '@/stores/app';
import HintComponent from "@/components/SpecialComponents/HintComponent.vue";

export default {
  name: 'SearchBarVue',
  setup() {
    return { appStore: useAppStore() };
  },
  data() {
    return {
      states: [],
      categories: [],
      currentCategory: '',
      state: 'placeholder',
      name: '',
      specName: '',
      specCategory: ''
    };
  },
  components: {HintComponent, SearchFormButton, DropdownVue, InputVue },
  mounted() {
    this.getStatesAndCategories();
  },
  methods: {
    getStatesAndCategories() {
      axios.get('/State').then(res => {
        res.data.forEach((item) => this.states.push({ name: item.name, value: `${item.id}` }));
      });
      axios.get('/Categories').then(res => {
        res.data.forEach((item) => this.categories.push({ name: item.name, id: `${item.id}` }));
      });
    },
    setSearchParams() {
      this.$router.push({ path: '/browser', query: { name: this.name, state: this.state, category: this.currentCategory } });
    }
  }
};
</script>

<style scoped lang='scss'>
.header-container {
  &__hero {
    position: relative;
    min-height: 520px;
    background-image: url('https://images.unsplash.com/photo-1583337130417-3346a1be7dee?q=80&w=1920&auto=format&fit=crop');
    background-size: cover;
    background-position: center;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  &__overlay {
    position: absolute;
    inset: 0;
    background: rgba(31, 41, 55, .62);
  }
  &__hero-content {
    position: relative;
    z-index: 1;
    max-width: 900px;
    text-align: center;
    color: #fff;
    padding: 40px 16px;
    h1 {
      font-size: clamp(3.2rem, 5vw, 5.8rem);
      line-height: 1.15;
      margin-bottom: 16px;
    }
    p {
      font-size: 2rem;
      margin-bottom: 24px;
      color: #e5e7eb;
    }
  }
  &__hsearch-bar-wrap {
    width: min(1100px, calc(100% - 32px));
    margin: -64px auto 0;
    background: #fff;
    border-radius: 12px;
    box-shadow: 0 15px 40px rgba(0, 0, 0, .12);
    padding: 24px;
    position: relative;
    z-index: 5;
    h2 {
      text-align: center;
      margin-top: 0;
      margin-bottom: 24px;
      font-size: 3rem;
      color: #111827;
    }
  }
  &__hsearch-bar {
    display: grid;
    grid-template-columns: 1fr 1fr auto;
    gap: 16px;
    align-items: stretch;
    margin-bottom: 18px;
  }
  &__hservices-list {
    margin-top: 8px;
    display: grid;
    grid-template-columns: repeat(2, minmax(0, 1fr));
    gap: 10px;
    text-align: center;
    &__srv-span {
      cursor: pointer;
      border: 1px solid #f3f4f6;
      border-radius: 8px;
      padding: 12px 14px;
      display: inline-block;
      transition: .2s;
      width: 100%;
      box-sizing: border-box;
      font-weight: 500;
      color: #374151;
      &.active,
      &:hover {
        border-color: #10b981;
        box-shadow: 0 4px 12px rgba(16, 185, 129, .12);
        color: #10b981;
      }
    }
    &__srv-btn {
      border: 1px solid #f3f4f6;
      background: #fff;
      border-radius: 10px;
      min-height: 58px;
      padding: 10px 14px;
      cursor: pointer;
      transition: border-color .2s ease, box-shadow .2s ease, transform .15s ease, color .2s ease;
      color: #374151;

      &:hover {
        border-color: #10b981;
        box-shadow: 0 6px 16px rgba(0, 0, 0, .08);
        transform: translateY(-1px);
      }

      &:focus {
        outline: none;
        border-color: #10b981;
        box-shadow: 0 0 0 1px #10b981, 0 0 0 4px rgba(16, 185, 129, .15);
      }

      &.active {
        border-color: #10b981;
        background: #ecfdf5;
        color: #047857;
        box-shadow: 0 6px 16px rgba(16, 185, 129, .2);
      }
    }
    &__srv-label {
      font-size: 1.6rem;
      font-weight: 500;
      line-height: 1.2;
      display: inline-block;
    }
  }
}
@media (max-width: 900px) {
  .header-container__hsearch-bar {
    grid-template-columns: 1fr;
  }
  .header-container__hservices-list {
    grid-template-columns: 1fr;
  }
  .header-container__hsearch-bar-wrap {
    width: auto;
  }
}
.find-specialist-btn {
  background: #ffffff;
  border-radius: 999px;
  padding: 12px 24px;
  margin-top: 20px;
  display: inline-block;
  color: #10b981;
  font-weight: 700;
  transition: .2s;
  text-decoration: none;
  &:hover {
    background: #f3f4f6;
    color: #10b981;
  }
}
</style>